/**
 * URL route mapping for the application.
 * Maps URL paths to internal view names used by App.js state routing.
 */
export const URL_ROUTES = {
  '/services-admin': 'servicesAdmin',
  '/blog-admin': 'blogAdmin',
  '/careers-admin': 'careersAdmin',
  '/coaches-admin': 'coachesAdmin',
  '/case-studies-admin': 'caseStudiesAdmin',
  '/resources-admin': 'resourcesAdmin',
  '/partners-admin': 'partnersAdmin',
  '/subscriptions-admin': 'subscriptionsAdmin',
  '/ab-test-admin': 'abTestAdmin',
  '/legacy-usage': 'legacyUsage',
  '/analytics': 'analytics',
  '/email-templates': 'emailTemplates',
  '/blog': 'blog',
  '/case-studies': 'caseStudies',
  '/resources': 'resources',
  '/resources-detail': 'resourceDetail',
  '/careers': 'careers',
  '/coaches': 'coaches',
  '/shop': 'shop',
  '/services': 'shop',
  '/checkout': 'checkout',
  '/privacy': 'privacy',
  '/terms': 'terms',
  '/about': 'aboutUs',
  '/methodology': 'methodology',
  '/payment-success': 'paymentSuccess',
  '/payment-failure': 'paymentFailure',
  '/subscribers-admin': 'subscribersAdmin',
  '/discount-codes-admin': 'discountCodesAdmin',
};

/**
 * Reverse mapping: view name → URL path.
 * Used to update the browser URL bar when navigating.
 */
export const VIEW_TO_URL = {
  home: '/',
  shop: '/services',
  blog: '/blog',
  caseStudies: '/case-studies',
  resources: '/resources',
  resourceDetail: '/resources',
  careers: '/careers',
  coaches: '/coaches',
  checkout: '/checkout',
  privacy: '/privacy',
  terms: '/terms',
  aboutUs: '/about',
  methodology: '/methodology',
  paymentSuccess: '/payment-success',
  paymentFailure: '/payment-failure',
  servicesAdmin: '/services-admin',
  blogAdmin: '/blog-admin',
  careersAdmin: '/careers-admin',
  coachesAdmin: '/coaches-admin',
  caseStudiesAdmin: '/case-studies-admin',
  resourcesAdmin: '/resources-admin',
  partnersAdmin: '/partners-admin',
  subscriptionsAdmin: '/subscriptions-admin',
  abTestAdmin: '/ab-test-admin',
  legacyUsage: '/legacy-usage',
  analytics: '/analytics',
  emailTemplates: '/email-templates',
  subscribersAdmin: '/subscribers-admin',
  discountCodesAdmin: '/discount-codes-admin',
};

/**
 * Navigate to a view and update the browser URL.
 */
export const navigateTo = (setCurrentView, view, extras) => {
  setCurrentView(view);
  const url = VIEW_TO_URL[view] || '/';
  window.history.pushState({ view, ...extras }, '', url);
  window.scrollTo({ top: 0 });
};
